import { NgModule } from '@angular/core';

import { MasterMasterGroupsFundosActions } from './master-master-groups-fundos.actions';

@NgModule({
  providers: [
    MasterMasterGroupsFundosActions
  ]
})
export class MasterMasterGroupsFundosActionsModule {}
